/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonContingentInfo,
    JsonContingentInfoFromJSON,
    JsonContingentInfoFromJSONTyped,
    JsonContingentInfoToJSON,
} from './JsonContingentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonContingentInfo
 */
export interface ApiResultOfJsonContingentInfo {
    /**
     * 
     * @type {JsonContingentInfo}
     * @memberof ApiResultOfJsonContingentInfo
     */
    data?: JsonContingentInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonContingentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonContingentInfo
     */
    result?: ApiResultOfJsonContingentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonContingentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonContingentInfoFromJSON(json: any): ApiResultOfJsonContingentInfo {
    return ApiResultOfJsonContingentInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonContingentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonContingentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonContingentInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonContingentInfoToJSON(value?: ApiResultOfJsonContingentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonContingentInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

